import { type FC } from "react";
import { Link } from "react-router";

import { WorkflowMark } from "./workflow_mark";

// Masthead scale, matching the blog's shipped lockup (blog.css `.blog-page
// .logo`) rather than the nav's 30x25 — the values are reproduced as utilities
// because those rules are scoped under `.blog-page` and never reach this tree.
export const Logo: FC = () => (
  <Link
    to="/"
    className="flex items-center gap-[14px] select-none md:gap-[18px]"
  >
    <WorkflowMark className="block h-10 w-12 md:h-[55px] md:w-[66px]" />

    <span className="text-[22px] leading-none font-medium tracking-[0.186em] text-[#414141] md:text-[30px]">
      WORKFLOW LABS
    </span>
  </Link>
);
